<template>
  <div class="contai_img">
    <img src="../assets/timg.png" alt="" />
    <div class="containers">
      <div class="contai">
        <h1>典当后台管理系统</h1>
      </div>
      <div class="from_input">
        <el-form
          :model="ruleForm"
          ref="ruleForm"
          label-width="60px"
          class="demo-ruleForm"
        >
          <el-form-item
            label="账号"
            prop="name"
            :rules="{
              required: true,
              message: '账号不能为空',
              trigger: 'blur',
            }"
          >
            <el-input v-model="ruleForm.name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item
            label="密码"
            prop="pass"
            :rules="{
              required: true,
              message: '密码不能为空',
              trigger: 'blur',
            }"
            class="inputs"
          >
            <el-input
              type="password"
              v-model="ruleForm.pass"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item> -->
          <div class="btn_a">
            <el-button type="primary" @click="submitForm('ruleForm')">登录</el-button>
            <el-button @click="resetForm('ruleForm')">重置</el-button>
          </div>

          <!-- </el-form-item> -->
        </el-form>
      </div>
      <div class="footer">
        版权所有:东莞市长安典当行有限责任公司 备案号:<a href="https://beian.miit.gov.cn"
          >粤ICP备20072504号</a
        >
        <!-- <el-button @click="resetForm('ruleForm')">强制刷新</el-button> -->
        <span class="qzSx">
          <!-- <button type="button" @click="reset">Reset token</button> -->
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
export default {
  inject: ["reload"],
  name: "Login",
  data() {
    return {
      ACCESS_TOKEN: "", //ACCESS_TOKEN
      ruleForm: {
        name: "",
        pass: "",
        year: "",
      },
    };
  },

  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          //账号密码都填写完

          //把账号密码发到后端匹配，返回的length=1 则验证通过，返回的length=0，则验证不通过
          // this.getuser();

          //微信云开发账号密码验证方式

          //    this.axios
          // .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          //   env: "changan2020-qtz0s",
          //   query:
          //     'db.collection("userdatas").where({name:"' +
          //     this.ruleForm.name +
          //     '",pass:"' +
          //     this.ruleForm.pass +
          //     '"}).get()',
          // })
          // .then((res) => {
          //   console.log(res)
          //   if(res.data.errcode == 40001){
          //     //密钥过期
          //       this.$notify.error({
          //       title: '错误提示',
          //       message: '密钥过期啦，请刷新页面'
          //     });

          //   }else{
          //       res.data.data.forEach((element, index, array) => {
          //       array[index] = JSON.parse(element)
          //       });

          //     if(res.data.data.length == 1){
          //      window.location.href = "/whens";
          //      sessionStorage.setItem("token", res.data.data[0].token);
          //   }else{
          //     this.$message.error("账号或密码错误，请重新输入");
          //   }
          //      }
          // });

          //独立账号接口验证方式

          // this.axios.post("/test/getData",{data:{
          //    username:this.ruleForm.name,
          //    password:this.ruleForm.pass
          // }
          // }).then(res=>{
          //   console.log(res)
          // })

          //"/getUser/getData"
          this.axios
            .post("/getUser/getData", {
              data: {
                username: this.ruleForm.name,
                password: this.ruleForm.pass,
              },
            })
            .then((res) => {
              if (res.data.state == false) {
                this.$message.error("账号或密码错误，请重新输入");
              } else {
                if (res.data[0].state == true) {
                  //账号密码正确登录成功
                  window.location.href = "/whens";
                  sessionStorage.setItem("token", res.data[1].tokenId);
                  sessionStorage.setItem("userId", res.data[2]._id);
                  sessionStorage.setItem("id", res.data[3].id);
                }
              }
            });
        } else {
          return false;
        }
      });
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    //重置密钥
    reset() {
      this.axios.get("/send/getToken").then((res) => {
        this.axios
          .post("/send/setToken", {
            data: {
              token: this.ACCESS_TOKEN,
              time: dayjs(res.data[0].time)
                .subtract(3, "hour")
                .format("YYYY-MM-DD HH:mm:ss"),
            },
          })
          .then(() => {
            this.$notify({
              title: "密钥重置成功",
              message: dayjs().format("YYYY-MM-DD HH:mm:ss") + "密钥已重置成功",
              type: "success",
            });
            this.reload();
          });
      });
    },
  },
  //生命周期函数，组件创建时
  created() {
    this.year = dayjs().year();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
html {
  margin: 0 0;
  padding: 0 0;
}
.contai_img {
  /* background: url("../assets/timg.png"); */
  width: 100%;
  height: 100vh;
  /* z-index: 1;
  position: absolute; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.contai_img img {
  width: 100%;
  height: 100%;
}
.contai {
  width: 100%;
}
.containers {
  position: absolute;
  top: 30vh;
  left: 35vw;
  padding: 0 130px;
  background-color: #ffffff;
  border-radius: 10px;
  filter: alpha(Opacity=85);
  -moz-opacity: 0.9;
  opacity: 0.9;
  /* margin: 0 auto; */
}
.contai {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.from_input {
  width: 86%;
  margin: 80px auto;
}

.btn {
  margin: 50px auto;
}
.inputs {
  margin: 50px auto;
}
.footer {
  width: 100%;
  font-size: 14px;
  color: #575454;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.btn_a {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.qzSx {
  margin: 0 10px;
}
</style>
